export const state = {
  NOTIFICATION: 'notification',
  NOTIFY: 'notify',
};

export const getters = {
  NOTIFICATION_EXISTS: 'notificationExists',
};

export const mutations = {
  SET_NOTIFICATION: 'setNotification',
  SET_NOTIFY: 'setNotify',
};

export const actions = {
  NOTIFY: 'notify',
  NOTIFY_SUCCESS: 'notifySuccess',
  NOTIFY_ERROR: 'notifyError',
};
